export default __webpack_public_path__ + "static/media/ad.eb626b08.svg";